function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5,14.513L1.987,14.625C1.159,14.632 0.493,15.311 0.501,16.138C0.508,16.966 1.186,17.632 2.014,17.625L14.5,17.513L14.5,30C14.5,30.828 15.172,31.5 16,31.5C16.828,31.5 17.5,30.828 17.5,30L17.5,17.487L30.013,17.375C30.841,17.368 31.507,16.689 31.499,15.862C31.492,15.034 30.814,14.368 29.986,14.375L17.5,14.487L17.5,2C17.5,1.172 16.828,0.5 16,0.5C15.172,0.5 14.5,1.172 14.5,2L14.5,14.513Z"
});
var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.61231311.svg";
export { ForwardRef as ReactComponent };